<div class="px-3">

  <div class="rem-text-default mb-6">
    <div class="flex align-items-end">

      <div class="rem-bg-light px-3 py-3 mr-2">
        <i class="pi pi-users font-medium text-xl"></i>
      </div>
      <div>
        <div class="text-2xl font-medium">Creditor Webhook Settings</div>
        <div class="text-right mt-2">Manage webhook settings of a creditor</div>
      </div>
      
    </div>
  </div>


 <div class="flex align-items-center justify-content-between">
    
      <div class="mt-5 flex gap-2" >
         <creditor-autocomplete
            (onSelect)="onSelectCreditor($event)"
          ></creditor-autocomplete>    
    </div>
     
    

     <div class="flex flex-wrap gap-2">      
    
      <remitter-button   
        (click)="onOpenSideBar()" 
        label='Add New'
        icon='plus'
        severity='primary'
        [disabled]="!selectedCreditorId"
      >     
      </remitter-button>
     </div>
</div>

<div class="mt-4">
     <div 
     *ngIf="!hasTableData && creditorCompanyName"
      style="text-align:center; margin-top:9rem; color: #336699; font-size: 1rem;">
                    🚫 No records found for {{ creditorCompanyName }}
      </div>

    <p-table
        *ngIf="hasTableData"
        [value]="webhookSettingsList" [paginator]="true"
                                           [rows]="5"
                                           [tableStyle]="{ 'min-width': '50rem' }"
                                           [rowsPerPageOptions]="[5, 10, 20]">
        <ng-template pTemplate="header">
            <tr class="text-xs">
                <th>Webhook Handler Setting Id</th>
                <th>Operation Type</th>
                <th>Event Status</th>
                <th>Endpoint Uri</th>
                <th>Payload Content Type</th>                
                <th>Batch Interval(sec)</th>
                <th>Batch Size</th>               
                <th>Is Direct Transfer</th>  
                <th>Is Send Message Content</th>     
                <th>Max Retry Events</th>       
                <th>Is Enabled</th>    
                <th>Action</th> 
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-settings>
            <tr class="text-xs">
                <td>{{ settings.webhookHandlerSettingId }}</td>
                <td>{{ settings.operationType }}</td>
                <td>{{ settings.eventStatus }}</td>
                <td>{{ settings.endpointUri }}</td>
                <td>{{ settings.payloadContentType }}</td>      
                <td>{{ settings.batchIntervalInSeconds }}</td> 
                <td>{{ settings.batchSize }}</td>
                <td>{{ settings.directTransfer }}</td>
                <td>{{ settings.sendMessageContent }}</td>
                <td>{{ settings.maxRetryEvents }}</td>
                <td>{{ settings.isEnabled }}</td>
                <td>
                    <div class="flex align-items-center">
                        <icon-button
                          pTooltip='Edit'
                          tooltipPosition='left'
                          (click)="onOpenSideBar(settings)"
                          [icon]="'pencil'"
                          [styleClass]="'mr-1'"
                        />

                      
                      </div>
                </td>       
            </tr>
        </ng-template>
    </p-table>
</div>

</div>



<p-sidebar [(visible)]="isSideBarVisible" styleClass="w-10" position="right">
    <div class="bg-white shadow-3 border-round p-4">
      <div class="text-xl font-medium">{{ payload.webhookHandlerSettingId? 'Edit ' : 'Add New '}} Webhook Settings</div>
      <div class="grid mt-2">
        <div  class="col-12 md:col-3 mt-4">
          <p-floatLabel>
            <p-dropdown  
              [filter]="true"                     
              [options]="operationTypes"
              [(ngModel)]="payload.operationType"
              optionLabel="label" 
              optionValue="value"               
              class="w-full" 
              styleClass="w-full"
              id="operationType" 
              />
            <label for="operationType">Operation Type</label>
          </p-floatLabel>
        </div>

         <div  class="col-12 md:col-3 mt-4">
          <p-floatLabel>
            <input type="text" pInputText  class="w-full" [(ngModel)]="payload.eventStatus"  />           
            <label for="eventStatus">Event Status</label>
          </p-floatLabel>
        </div>

        <div  class="col-12 md:col-3 mt-4">
          <p-floatLabel>
            <input type="text" pInputText  id="endpointUri" class="w-full" [(ngModel)]="payload.endpointUri"  />
            <label for="endpointUri">Endpoint Uri</label>
          </p-floatLabel>
          
           <div class="p-1 text-red-700 font-bold" *ngIf="validationErrors.endpointUri">
            <i class="pi pi-exclamation-triangle text-xs font-bold"></i> {{validationErrors.endpointUri}}
          </div>
        </div>

         <div  class="col-12 md:col-3 mt-4">
          
          <p-floatLabel>
            <p-dropdown    
              [filter]="true"
              [options]="contentTypes"
              [(ngModel)]="payload.payloadContentType"
              optionLabel="label"   
              optionValue="value"               
              class="w-full" 
              styleClass="w-full"
              id="payloadContentType" />
            <label for="payloadContentType">Payload Content Type</label>
          </p-floatLabel>

         
        </div>

         <div  class="col-12 md:col-3 mt-4">
            <p-floatLabel>
              <p-inputNumber 
                    [(ngModel)]="payload.batchIntervalInSeconds"
                    class="w-full"
                    styleClass="w-full"
                    inputId="batchIntervalInSeconds" 
                     [maxFractionDigits]="5"                    
              /> 
              <label for="batchIntervalInSeconds">Batch Interval(seconds)</label>
            </p-floatLabel>
        </div>

        <div  class="col-12 md:col-3 mt-4">
            <p-floatLabel>
              <p-inputNumber 
                    [(ngModel)]="payload.batchSize"
                    class="w-full"
                    styleClass="w-full"
                    inputId="batchSize"   
                    [maxFractionDigits]="5"                  
              /> 
              <label for="batchSize">Batch Size</label>
            </p-floatLabel>
        </div>

       
        <div  class="col-12 md:col-3 mt-4">            
            <div class="flex align-items-center gap-2">
              <label for="directTransfer">Is Direct Transfer</label>            
              <p-selectButton
                  [options]="selectButtonOptions" 
                  [(ngModel)]="payload.directTransfer" 
                  optionLabel="label" 
                  optionValue="value"  inputId="directTransfer"           
              />
            </div>
        </div>

         <div  class="col-12 md:col-3 mt-4">            
            <div class="flex align-items-center gap-2">
              <label for="sendMessageContent">Is Send Message Content</label>            
              <p-selectButton
                  [options]="selectButtonOptions" 
                  [(ngModel)]="payload.sendMessageContent" 
                  optionLabel="label" 
                  optionValue="value"  
                  inputId="sendMessageContent"           
              />
            </div>
        </div>

        <div  class="col-12 md:col-3 mt-4">
            <p-floatLabel>
              <p-inputNumber 
                    [(ngModel)]="payload.maxRetryEvents"
                    class="w-full"
                    styleClass="w-full"
                    inputId="maxRetryEvents"  
              /> 
              <label for="maxRetryEvents">Maximum Retry Events</label>
            </p-floatLabel>
        </div>

        <div  class="col-12 md:col-3 mt-4">            
            <div class="flex align-items-center gap-2">
              <label for="isEnabled">Is Enabled</label>            
              <p-selectButton
                  [options]="selectButtonOptions" 
                  [(ngModel)]="payload.isEnabled" 
                  optionLabel="label" 
                  optionValue="value"  
                  inputId="isEnabled"           
              />
            </div>
        </div>
      </div>
     
     
      <div class="flex justify-content-end mt-4">
        <remitter-button
          (click)="onSave()" 
          label='Save'
          icon='send'
        >     
        </remitter-button>
      </div>
      </div>
</p-sidebar>
